// x-privacy-notification.js

/*
Old, primitive cookie-banner used as a temporary solution awaiting something better.
Used by foreninger.uio.no, circle-u, flymed and hlsenteret as of april 2024.
*/

export default function privacyNotification() {
  var privacyNotification = document.getElementById('privacy-notification');
  if (privacyNotification) {
    var privacyNotificationClose = privacyNotification.querySelector("button");
    var cookieName = "SITE_COOKIES_OPT_IN";
    var windowEqualsTop = (window == top);
    var cookieNotExists = !readCookie(cookieName);

    if(windowEqualsTop && navigator.cookieEnabled && cookieNotExists) {

      // Default show notification
      privacyNotification.classList.add('visible');

      // Close-button click
      privacyNotificationClose.addEventListener('click', function () {
        // Opt-in for 15 years (ceiled days)
        createCookie(cookieName, "yes", 5479);
        privacyNotification.classList.remove('visible');
      });
    }
    else {
      // Hide notification
      privacyNotification.classList.remove('visible');
    }
  }

  // Cookie utilities from quirksmode.org
  function createCookie(name, value, days) {
    var expires = "";
    if (days) {
      var date = new Date();
      date.setTime(date.getTime()+(days*24*60*60*1000));
      expires = "; expires="+date.toGMTString();
    } else {
      expires = "";
    }
    document.cookie = name+"="+value+expires+"; path=/";
  }

  function readCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for(var i = 0, len = ca.length; i < len; i++) {
      var c = ca[i];
      var cLen = c.length;
      while (c.charAt(0)==' ') c = c.substring(1, cLen);
      if(c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, cLen);
    }
    return null;
  }

  function eraseCookie(name) {
    createCookie(name,"",-1);
  }
}